import { styled, Button, DialogContent, Grid, Theme } from '@material-ui/core';
import { StyledDialog } from '@room-match/shared-ui-components';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_DIALOG_FIELDS_FLOATING,
  LIGHT_DIALOG_CONTENT_BACKGROUND,
  LIGHT_TEXT,
  PLAIN_TEXT,
  PLAIN_TEXTBOX_INPUT,
  PRIMARY_BUTTON_BACKGROUND_TRANSPARENT,
  PRIMARY_BUTTON_BACKGROUND,
} = COLORS;

export const CloseButton = styled(Button)({
  marginLeft: 'auto',
  cursor: 'pointer',
  minWidth: 'unset',
  borderRadius: '100%',
  width: 30,
  height: 30,
  background: 'none',
});

export const CustomDialog = styled(StyledDialog)(({ theme }) => ({
  '&.paper': {
    minWidth: '85%',
    minHeight: '90%',
  },
  '& .MuiDialog-paperWidthSm': {
    maxWidth: '892px !important',
  },
}));

export const CustomDialogContent = styled(DialogContent)(({ theme }) => ({
  background: theme.palette.type === 'dark' ? DARK_DIALOG_FIELDS_FLOATING : LIGHT_DIALOG_CONTENT_BACKGROUND,
  display: 'flex',
  flexDirection: 'column',
  // height: 630,
  [theme.breakpoints.down('xs')]: {
    padding: '40px 25px 50px!important',
  },
}));

export const Header = styled('div')({
  marginBottom: 30,
  textAlign: 'center',
  wordBreak: 'break-word',
});

export const Content = styled(Grid)({
  maxHeight: 700,
  overflowY: 'auto',
  marginBottom: 20,
  '& > div:not(:last-child)': {
    marginBottom: 10,
  },

  '& .MuiOutlinedInput-root': {
    height: '50px!important',
    fontSize: 14,
    background: PLAIN_TEXTBOX_INPUT,
  },

  '& .MuiFormLabel-root': {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '13px',
    letterSpacing: '1px',
    alignItems: 'center',
    color: PLAIN_TEXT,

    '& .MuiBox-root': {
      padding: '2px 4px 1px 5px',
      border: '1px solid',
      borderRadius: '100%',
      fontSize: '12px',
    },
  },

  '& .MuiSelect-iconOutlined': {
    right: '0',
    top: '22px',
  },

  '& .MuiSelect-iconOpen': {
    top: '2px',
    right: '13px',
  },
});

export const TwoColumn = styled('div')(({ theme }) => ({
  display: 'grid',
  gap: '10px 40px',
  gridTemplateColumns: '240px 240px',
  margin: '40px 0',

  [theme.breakpoints.down(1000)]: {
    padding: 0,
  },
  [theme.breakpoints.down('xs')]: {
    gridTemplateColumns: 'unset',
  },
}));

export const Column = styled('div')({
  display: 'flex',
  gap: 25,
  justifyContent: 'flex-start',
  width: '100%',
  maxWidth: 200,
});

export const CheckboxContainer = styled(Grid)({
  letterSpacing: 0.4,
  marginTop: 10,

  '& .MuiTypography-root': {
    fontSize: 15,
  },
});

export const ActionsContainer = styled('div')({
  marginTop: 'auto',
  display: 'flex',
  gap: 15,
  justifyContent: 'center',
});

export const CustomButton = styled(Button)({
  borderRadius: 5,
  background: PRIMARY_BUTTON_BACKGROUND,
  height: 44,
  maxWidth: 165,
  color: PLAIN_TEXT,
  '&:hover': {
    backgroundColor: PRIMARY_BUTTON_BACKGROUND_TRANSPARENT,
  },
});

export const FooterContainer = styled('div')({
  marginTop: 'auto',
  display: 'flex',
  gap: 30,
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',

  '& p': {
    maxWidth: 416,
    textAlign: 'center',
    wordBreak: 'normal',
    color: LIGHT_TEXT,
  },
});
